















import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import {Route} from 'vue-router';
import {Tab} from '@/types/Tabs';

@Component({
  name: 'RouterTabs',
})
export default class RouterTabs extends Vue {
  @Prop({type: Array, required: true}) readonly tabs!: Array<Tab>

  private get tabIndex(): number {
    return this.tabs.findIndex(tab => tab.pathName === this.$route.name);
  }

  @Watch('$route', {immediate: true}) onRouteChange(to: Route): void {
    if (to.name === 'Edit') {
      this.$router.replace({name: this.tabs[0].pathName});
    }
  }

  private changeView(tabIndex: number): void {
    this.$router.push({name: this.tabs[tabIndex].pathName});
  }
}
